import { render, staticRenderFns } from "./ms.vue?vue&type=template&id=515504ad&scoped=true"
import script from "./ms.vue?vue&type=script&lang=js"
export * from "./ms.vue?vue&type=script&lang=js"
import style0 from "./ms.vue?vue&type=style&index=0&id=515504ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515504ad",
  null
  
)

export default component.exports